import React, { Component } from 'react';


class Header extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false
        };
    }

    render() {
        const { children } = this.props;

        return (
        <div className="pd-content-top col-sm-12 col-md-8 col-lg-8 col-lg-offset-2 col-md-offset-2 text-center header-container">
            <img alt="Logo" className="intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
            { children && children }
        </div>
        );
    }
}


export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/